import type { TMessages } from '@/types/TMessages'

export const messages = {
  validTo: 'Действует до',
  noVat: 'Цена\nбез НДС',
  sendRequest: 'Откликнуться',
} satisfies TMessages
